import { Tooltip } from '@devexpress/dx-react-chart-material-ui';
import useStyles from './style';

const TooltipOverlay = ({ ...props }: Tooltip.OverlayProps) => {
  const classes = useStyles();

  return <Tooltip.Overlay {...props} className={classes.overlayContainer} />;
};

export default TooltipOverlay;
